module.exports = __webpack_public_path__ + "img/a25fe1b.png";